import { useSelector } from 'react-redux';

import { StoreState } from '@bcp-nextgen-dx-touchpoint-framework/react-js';

import { AppState, ServiceError } from '../..';

export const useServiceError = (): ServiceError | undefined => {
	return useSelector((state: StoreState<AppState>) => state.appState.servicesState.error);
};
